export default {
  namespaced: true,
  state: {
    items: [],
    types: [],
    loading: false,
  },
  actions: {
    GetList({ commit, rootGetters, dispatch }) {
      commit('setField', { name: 'items', value: [] });
      rootGetters.axl.post('profiles/api/jobs/lk')
        .then((response) => {
          commit('setField', { name: 'items', value: response.data.items });
        })
        .catch((error) => {
          dispatch('HandleError', error, { root: true });
        });
    },
    GetTypes({ commit, rootGetters, dispatch }) {
      commit('setField', { name: 'types', value: [] });
      rootGetters.axl.post('profiles/api/jobs/types')
        .then((response) => {
          commit('setField', { name: 'types', value: response.data.items });
        })
        .catch((error) => {
          dispatch('HandleError', error, { root: true });
        });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
